import type {
  ServiceActivityState,
  ServiceRuntimeState,
  SystemOverviewResponse,
} from '../types/trade';

export type ServiceVisualState = ServiceRuntimeState | ServiceActivityState;

export function getServiceVisualState(status: ServiceVisualState) {
  if (status === 'gated') {
    return { className: 'gated', label: 'gated' };
  }

  if (status === 'active') {
    return { className: 'active', label: 'active' };
  }

  return { className: 'inactive', label: 'inactive' };
}

export function getSystemOverviewStateSections(data: SystemOverviewResponse) {
  return {
    runtimeServices: data.runtime_services,
    activityServices: data.activity_services,
  };
}
